module.exports = __webpack_public_path__ + "static/media/icon.859f1091.svg";